import type { PropsWithChildren } from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { mqMin, tok, tokPx, zIndex } from '@sunwebgroup/ui-components'

import { styled } from 'styled-components'

const Content = styled.div`
  background: ${tok('semantics_views_background_color')};
  border-radius: ${tokPx('semantics_overlays_corner_radius')};
  box-shadow: ${tok('primitives_box_shadows_level_4')};
  display: flex;
  flex-direction: column;
  max-height: 400px;
  max-width: 400px;
  outline: none;
  width: var(--radix-popover-trigger-width);
  z-index: ${zIndex.modalOrMobilePopover};
  @media ${mqMin('primitives_breakpoint_l_min')} {
    z-index: ${zIndex.popover};
  }
`

export function Popover({ children }: PropsWithChildren) {
  return (
    <PopoverPrimitive.Content asChild align="start" avoidCollisions={false}>
      <Content>{children}</Content>
    </PopoverPrimitive.Content>
  )
}
